import { useEffect } from 'react';
import { DFPManager } from 'react-dfp';
import { ConsultationType } from '../../common/AnalyticsContext/TrackingData';
import { PageType } from '../../common/GoogleAdsManager/constant';
import { FilterChoice } from '../../common/components/SearchHeader/types/FilterChoice';
import { env } from '../../common/util/env';
import { formatSpecialty } from '../../common/util/formatGAMSpecialty';
import { useHealthInterests } from '../../patient-accounts/health-interests/useHealthInterests';

export const useDfpTargeting = (filters: FilterChoice) => {
  const { userHealthInterests } = useHealthInterests();

  useEffect(() => {
    DFPManager.setTargetingArguments({
      env: env.GAM_ENVIRONMENT,
      pagetype: PageType.RESULTS,
      specialty: formatSpecialty(filters.topic?.specialist || ''),
      state: filters.location?.state || filters.location?.suburb?.state || '',
      suburb: filters.location?.suburb?.name || '',
      postcode: filters.location?.suburb?.postcode || '',
      bulkbill: filters.topic?.bulkBillingGp ? 'true' : 'false',
      telehealth: filters.flag === ConsultationType.TELEHEALTH ? 'true' : 'false',
      healthinterest: userHealthInterests.filter(item => item.subscribed).map(item => item.name),
    });

    DFPManager.load();
  }, [filters, userHealthInterests]);
};
